/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {FileUtils} from "../../../Utils";

export function FileSizeFieldViewer(props) {
	const {Value} = props;
	return Value != null ? FileUtils.GetFileSize(Value) : 'N/A';
}
